import ButtonBase from '@material-ui/core/ButtonBase';
import Paper from '@material-ui/core/Paper';
import {makeStyles} from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';
import {useHistory} from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  fullWidth: {
    width: '100%',
    fontSize: 0,
    // borderBottomRightRadius: 32,
    // borderBottomLeftRadius: 32,
    borderRadius: 15,
  },
  fullHeight: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
}));

export default React.memo(function ButtonImage({src, alt, ...props}) {
  const classes = useStyles();
  const history = useHistory();

  return (
    <ButtonBase
      className={clsx(classes.fullWidth, classes.fullHeight)}
      focusRipple
      {...props}
    >
      <Paper className={clsx(classes.fullWidth, classes.fullHeight)}>
        <img
          className={classes.fullWidth}
          src={src}
          alt={alt}
          onClick={() => {
            history.push('/app/advisers', {
              title: 'پزشکان و مشاوران آنلاین',
              params: {
                online: true,
              },
            });
          }}
        />
      </Paper>
    </ButtonBase>
  );
});
